import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';

@Injectable()
export class WaiveApiService {

    constructor(private http: ApiHttpClient) { }

    public waiveCancellation(id: camps.Guid): Observable<api.OperationResult> {
        return this.http.post<api.OperationResultValue<camps.CampPurchaseDetails>>(`waive/${id}/cancellationFee`,{}, true);
    }

    public waiveDiscounts(id: camps.Guid): Observable<api.OperationResult> {
        return this.http.post<api.OperationResultValue<camps.CampPurchaseDetails>>(`waive/${id}/discounts`,{}, true);
    }
}
